import { useCallback } from 'react'

import { useDeliveryMethodModal } from '@b-stock/fe-core/bstock-next/components'
import type {
  OrchestratedOfferingListingDetails,
  OrchestratedQuote,
} from '@b-stock/fe-core/bstock-next/queries'
import { centsToDollars } from '@b-stock/fe-core/bstock-react'

import { useCalculatedAdditionalCharges } from '@/buyer-portal/components/features/listing/hooks/useCalculatedAdditionalCharges'
import { getEditDeliveryMethodRedirectUri } from '@/buyer-portal/helpers/shipping'
import activeSubscriptionsQuery from '@/buyer-portal/queries/activeSubscriptionsQuery'

import { Payment } from '../Payment'

export const SimpleOfferPayment = ({
  listing,
  selectedQuote,
}: {
  listing: OrchestratedOfferingListingDetails
  selectedQuote?: OrchestratedQuote | null
}) => {
  const { offers, shipping } = listing

  const {
    editDeliveryMethod: openDeliveryMethodModal,
    deliveryMethodChangePending,
  } = useDeliveryMethodModal()

  const editDeliveryMethod = useCallback(
    () =>
      openDeliveryMethodModal({
        redirectURI: getEditDeliveryMethodRedirectUri(),
      }),
    [openDeliveryMethodModal]
  )

  const { data: sellerSubscription } = activeSubscriptionsQuery.useQuery(
    listing.accountId
  )

  const offer = offers?.filter((o) => o.offer.isActive)[0]?.offer

  const additionalCharges = useCalculatedAdditionalCharges({
    buyersPremium: sellerSubscription?.buyersPremium ?? 0,
    currentBidDollars: centsToDollars(
      offer?.lotAmount ?? listing.offering?.startOfferAmount ?? 0
    ),
    selectedQuote,
  })

  return (
    <Payment
      additionalCharges={additionalCharges}
      basePrice={additionalCharges.basis}
      editDeliveryMethod={editDeliveryMethod}
      loading={deliveryMethodChangePending}
      selectedQuote={selectedQuote}
      shipping={shipping}
      currentListing={listing}
      currency={listing.currency}
    />
  )
}
